/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let tukivitaSessionRateApiUrl = root.tukivitaSessionRateApiUrl.link;

export default {
    state: {
    },
    mutations: {
    },
    actions: {
        //Patch Tukivita Session Rate Action
        tukivitaSessionRateAction(context, payload) {
            return new Promise((resolve, reject) => {
                axios.patch(tukivitaSessionRateApiUrl, payload).then(res => {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
    },
    getters: {
    }
}